import _definePage_default_0 from '/www/wwwroot/pintukasir/resources/js/pages/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/www/wwwroot/pintukasir/resources/js/pages/[...error].vue?definePage&vue'
import _definePage_default_3 from '/www/wwwroot/pintukasir/resources/js/pages/access-control.vue?definePage&vue'
import _definePage_default_4 from '/www/wwwroot/pintukasir/resources/js/pages/apps/roles/index.vue?definePage&vue'
import _definePage_default_5 from '/www/wwwroot/pintukasir/resources/js/pages/apps/roles/[id]/edit.vue?definePage&vue'
import _definePage_default_6 from '/www/wwwroot/pintukasir/resources/js/pages/apps/user/list/index.vue?definePage&vue'
import _definePage_default_7 from '/www/wwwroot/pintukasir/resources/js/pages/attendance/kiosk.vue?definePage&vue'
import _definePage_default_8 from '/www/wwwroot/pintukasir/resources/js/pages/attendance/schedules.vue?definePage&vue'
import _definePage_default_9 from '/www/wwwroot/pintukasir/resources/js/pages/blog/index.vue?definePage&vue'
import _definePage_default_10 from '/www/wwwroot/pintukasir/resources/js/pages/blog/[slug].vue?definePage&vue'
import _definePage_default_11 from '/www/wwwroot/pintukasir/resources/js/pages/catalog/categories/index.vue?definePage&vue'
import _definePage_default_12 from '/www/wwwroot/pintukasir/resources/js/pages/catalog/modifier-groups/index.vue?definePage&vue'
import _definePage_default_13 from '/www/wwwroot/pintukasir/resources/js/pages/catalog/modifier-groups/[id]/edit.vue?definePage&vue'
import _definePage_default_14 from '/www/wwwroot/pintukasir/resources/js/pages/catalog/modifier-groups/create.vue?definePage&vue'
import _definePage_default_15 from '/www/wwwroot/pintukasir/resources/js/pages/catalog/products/index.vue?definePage&vue'
import _definePage_default_16 from '/www/wwwroot/pintukasir/resources/js/pages/catalog/products/[id]/index.vue?definePage&vue'
import _definePage_default_17 from '/www/wwwroot/pintukasir/resources/js/pages/catalog/products/[id]/edit.vue?definePage&vue'
import _definePage_default_18 from '/www/wwwroot/pintukasir/resources/js/pages/catalog/products/create.vue?definePage&vue'
import _definePage_default_19 from '/www/wwwroot/pintukasir/resources/js/pages/crm/broadcast-campaigns/index.vue?definePage&vue'
import _definePage_default_20 from '/www/wwwroot/pintukasir/resources/js/pages/crm/broadcast-campaigns/[id]/index.vue?definePage&vue'
import _definePage_default_21 from '/www/wwwroot/pintukasir/resources/js/pages/crm/broadcast-campaigns/create.vue?definePage&vue'
import _definePage_default_22 from '/www/wwwroot/pintukasir/resources/js/pages/crm/broadcast-templates/index.vue?definePage&vue'
import _definePage_default_23 from '/www/wwwroot/pintukasir/resources/js/pages/crm/broadcast-templates/[id]/edit.vue?definePage&vue'
import _definePage_default_24 from '/www/wwwroot/pintukasir/resources/js/pages/crm/broadcast-templates/create.vue?definePage&vue'
import _definePage_default_25 from '/www/wwwroot/pintukasir/resources/js/pages/daftar/index.vue?definePage&vue'
import _definePage_default_26 from '/www/wwwroot/pintukasir/resources/js/pages/daftar/status/[registrationCode].vue?definePage&vue'
import _definePage_default_27 from '/www/wwwroot/pintukasir/resources/js/pages/dashboards/analytics.vue?definePage&vue'
import _definePage_default_28 from '/www/wwwroot/pintukasir/resources/js/pages/expense/index.vue?definePage&vue'
import _definePage_default_29 from '/www/wwwroot/pintukasir/resources/js/pages/expense/[id]/edit.vue?definePage&vue'
import _definePage_default_30 from '/www/wwwroot/pintukasir/resources/js/pages/expense/categories/index.vue?definePage&vue'
import _definePage_default_31 from '/www/wwwroot/pintukasir/resources/js/pages/expense/create.vue?definePage&vue'
import _definePage_default_32 from '/www/wwwroot/pintukasir/resources/js/pages/fitur.vue?definePage&vue'
import _definePage_default_33 from '/www/wwwroot/pintukasir/resources/js/pages/forgot-password.vue?definePage&vue'
import _definePage_default_34 from '/www/wwwroot/pintukasir/resources/js/pages/help.vue?definePage&vue'
import _definePage_default_35 from '/www/wwwroot/pintukasir/resources/js/pages/inventory/ingredients/index.vue?definePage&vue'
import _definePage_default_36 from '/www/wwwroot/pintukasir/resources/js/pages/inventory/ingredients/[id]/index.vue?definePage&vue'
import _definePage_default_37 from '/www/wwwroot/pintukasir/resources/js/pages/inventory/ingredients/[id]/edit.vue?definePage&vue'
import _definePage_default_38 from '/www/wwwroot/pintukasir/resources/js/pages/inventory/ingredients/create.vue?definePage&vue'
import _definePage_default_39 from '/www/wwwroot/pintukasir/resources/js/pages/inventory/stock-adjustment/index.vue?definePage&vue'
import _definePage_default_40 from '/www/wwwroot/pintukasir/resources/js/pages/inventory/stock-movements/index.vue?definePage&vue'
import _definePage_default_41 from '/www/wwwroot/pintukasir/resources/js/pages/inventory/stock-opnames/index.vue?definePage&vue'
import _definePage_default_42 from '/www/wwwroot/pintukasir/resources/js/pages/inventory/stock-opnames/[id]/index.vue?definePage&vue'
import _definePage_default_43 from '/www/wwwroot/pintukasir/resources/js/pages/inventory/stock-opnames/create.vue?definePage&vue'
import _definePage_default_44 from '/www/wwwroot/pintukasir/resources/js/pages/inventory/units/index.vue?definePage&vue'
import _definePage_default_45 from '/www/wwwroot/pintukasir/resources/js/pages/kds/index.vue?definePage&vue'
import _definePage_default_46 from '/www/wwwroot/pintukasir/resources/js/pages/kds/[stationId].vue?definePage&vue'
import _definePage_default_47 from '/www/wwwroot/pintukasir/resources/js/pages/kontak.vue?definePage&vue'
import _definePage_default_48 from '/www/wwwroot/pintukasir/resources/js/pages/login.vue?definePage&vue'
import _definePage_default_49 from '/www/wwwroot/pintukasir/resources/js/pages/loyalty/index.vue?definePage&vue'
import _definePage_default_50 from '/www/wwwroot/pintukasir/resources/js/pages/not-authorized.vue?definePage&vue'
import _definePage_default_51 from '/www/wwwroot/pintukasir/resources/js/pages/order/scan/[qrToken].vue?definePage&vue'
import _definePage_default_52 from '/www/wwwroot/pintukasir/resources/js/pages/order/session-token/checkout.vue?definePage&vue'
import _definePage_default_53 from '/www/wwwroot/pintukasir/resources/js/pages/order/session-token/identify.vue?definePage&vue'
import _definePage_default_54 from '/www/wwwroot/pintukasir/resources/js/pages/order/session-token/menu.vue?definePage&vue'
import _definePage_default_55 from '/www/wwwroot/pintukasir/resources/js/pages/order/session-token/payment.vue?definePage&vue'
import _definePage_default_56 from '/www/wwwroot/pintukasir/resources/js/pages/order/session-token/status.vue?definePage&vue'
import _definePage_default_57 from '/www/wwwroot/pintukasir/resources/js/pages/platform/blog-posts/index.vue?definePage&vue'
import _definePage_default_58 from '/www/wwwroot/pintukasir/resources/js/pages/platform/blog-posts/[id]/edit.vue?definePage&vue'
import _definePage_default_59 from '/www/wwwroot/pintukasir/resources/js/pages/platform/blog-posts/create.vue?definePage&vue'
import _definePage_default_60 from '/www/wwwroot/pintukasir/resources/js/pages/platform/login.vue?definePage&vue'
import _definePage_default_61 from '/www/wwwroot/pintukasir/resources/js/pages/platform/orders/index.vue?definePage&vue'
import _definePage_default_62 from '/www/wwwroot/pintukasir/resources/js/pages/platform/registrations/index.vue?definePage&vue'
import _definePage_default_63 from '/www/wwwroot/pintukasir/resources/js/pages/platform/seo-settings/index.vue?definePage&vue'
import _definePage_default_64 from '/www/wwwroot/pintukasir/resources/js/pages/platform/settings/index.vue?definePage&vue'
import _definePage_default_65 from '/www/wwwroot/pintukasir/resources/js/pages/platform/subscriptions/index.vue?definePage&vue'
import _definePage_default_66 from '/www/wwwroot/pintukasir/resources/js/pages/platform/tenants/index.vue?definePage&vue'
import _definePage_default_67 from '/www/wwwroot/pintukasir/resources/js/pages/platform/tenants/[id]/edit.vue?definePage&vue'
import _definePage_default_68 from '/www/wwwroot/pintukasir/resources/js/pages/platform/tenants/create.vue?definePage&vue'
import _definePage_default_69 from '/www/wwwroot/pintukasir/resources/js/pages/platform/testimonials/index.vue?definePage&vue'
import _definePage_default_70 from '/www/wwwroot/pintukasir/resources/js/pages/platform/tickets/index.vue?definePage&vue'
import _definePage_default_71 from '/www/wwwroot/pintukasir/resources/js/pages/platform/tickets/[id].vue?definePage&vue'
import _definePage_default_72 from '/www/wwwroot/pintukasir/resources/js/pages/pos/index.vue?definePage&vue'
import _definePage_default_73 from '/www/wwwroot/pintukasir/resources/js/pages/pos/index-copy.vue?definePage&vue'
import _definePage_default_74 from '/www/wwwroot/pintukasir/resources/js/pages/pos/qris-print/[id].vue?definePage&vue'
import _definePage_default_75 from '/www/wwwroot/pintukasir/resources/js/pages/pos/queue-board.vue?definePage&vue'
import _definePage_default_76 from '/www/wwwroot/pintukasir/resources/js/pages/pos/receipt/[id].vue?definePage&vue'
import _definePage_default_77 from '/www/wwwroot/pintukasir/resources/js/pages/pos-display/[shiftId].vue?definePage&vue'
import _definePage_default_78 from '/www/wwwroot/pintukasir/resources/js/pages/pos-display/connect.vue?definePage&vue'
import _definePage_default_79 from '/www/wwwroot/pintukasir/resources/js/pages/pos-display/queue-board.vue?definePage&vue'
import _definePage_default_80 from '/www/wwwroot/pintukasir/resources/js/pages/privacy.vue?definePage&vue'
import _definePage_default_81 from '/www/wwwroot/pintukasir/resources/js/pages/promotions/index.vue?definePage&vue'
import _definePage_default_82 from '/www/wwwroot/pintukasir/resources/js/pages/purchase/orders/index.vue?definePage&vue'
import _definePage_default_83 from '/www/wwwroot/pintukasir/resources/js/pages/purchase/orders/[id]/index.vue?definePage&vue'
import _definePage_default_84 from '/www/wwwroot/pintukasir/resources/js/pages/purchase/orders/[id]/edit.vue?definePage&vue'
import _definePage_default_85 from '/www/wwwroot/pintukasir/resources/js/pages/purchase/orders/create.vue?definePage&vue'
import _definePage_default_86 from '/www/wwwroot/pintukasir/resources/js/pages/purchase/receipt-scan/index.vue?definePage&vue'
import _definePage_default_87 from '/www/wwwroot/pintukasir/resources/js/pages/purchase/receipt-scan/[id].vue?definePage&vue'
import _definePage_default_88 from '/www/wwwroot/pintukasir/resources/js/pages/purchase/receivings/index.vue?definePage&vue'
import _definePage_default_89 from '/www/wwwroot/pintukasir/resources/js/pages/purchase/receivings/[id]/index.vue?definePage&vue'
import _definePage_default_90 from '/www/wwwroot/pintukasir/resources/js/pages/purchase/receivings/create.vue?definePage&vue'
import _definePage_default_91 from '/www/wwwroot/pintukasir/resources/js/pages/purchase/suppliers/index.vue?definePage&vue'
import _definePage_default_92 from '/www/wwwroot/pintukasir/resources/js/pages/purchase/suppliers/[id]/edit.vue?definePage&vue'
import _definePage_default_93 from '/www/wwwroot/pintukasir/resources/js/pages/purchase/suppliers/create.vue?definePage&vue'
import _definePage_default_94 from '/www/wwwroot/pintukasir/resources/js/pages/reports/attendance.vue?definePage&vue'
import _definePage_default_95 from '/www/wwwroot/pintukasir/resources/js/pages/reports/dashboard.vue?definePage&vue'
import _definePage_default_96 from '/www/wwwroot/pintukasir/resources/js/pages/reports/expiring-stock.vue?definePage&vue'
import _definePage_default_97 from '/www/wwwroot/pintukasir/resources/js/pages/reports/inventory.vue?definePage&vue'
import _definePage_default_98 from '/www/wwwroot/pintukasir/resources/js/pages/reports/profit-loss.vue?definePage&vue'
import _definePage_default_99 from '/www/wwwroot/pintukasir/resources/js/pages/reports/sales.vue?definePage&vue'
import _definePage_default_100 from '/www/wwwroot/pintukasir/resources/js/pages/sales/orders/index.vue?definePage&vue'
import _definePage_default_101 from '/www/wwwroot/pintukasir/resources/js/pages/sales/orders/[id].vue?definePage&vue'
import _definePage_default_102 from '/www/wwwroot/pintukasir/resources/js/pages/sales/shifts/index.vue?definePage&vue'
import _definePage_default_103 from '/www/wwwroot/pintukasir/resources/js/pages/settings/[tab].vue?definePage&vue'
import _definePage_default_104 from '/www/wwwroot/pintukasir/resources/js/pages/settings/ai-status.vue?definePage&vue'
import _definePage_default_105 from '/www/wwwroot/pintukasir/resources/js/pages/settings/delivery-platforms.vue?definePage&vue'
import _definePage_default_106 from '/www/wwwroot/pintukasir/resources/js/pages/settings/order-types.vue?definePage&vue'
import _definePage_default_107 from '/www/wwwroot/pintukasir/resources/js/pages/settings/printers.vue?definePage&vue'
import _definePage_default_108 from '/www/wwwroot/pintukasir/resources/js/pages/settings/stations.vue?definePage&vue'
import _definePage_default_109 from '/www/wwwroot/pintukasir/resources/js/pages/staff/pin-setup/[token].vue?definePage&vue'
import _definePage_default_110 from '/www/wwwroot/pintukasir/resources/js/pages/support/index.vue?definePage&vue'
import _definePage_default_111 from '/www/wwwroot/pintukasir/resources/js/pages/support/[id].vue?definePage&vue'
import _definePage_default_112 from '/www/wwwroot/pintukasir/resources/js/pages/support/create.vue?definePage&vue'
import _definePage_default_113 from '/www/wwwroot/pintukasir/resources/js/pages/support.vue?definePage&vue'
import _definePage_default_114 from '/www/wwwroot/pintukasir/resources/js/pages/tables/index.vue?definePage&vue'
import _definePage_default_115 from '/www/wwwroot/pintukasir/resources/js/pages/tentang-kami.vue?definePage&vue'
import _definePage_default_116 from '/www/wwwroot/pintukasir/resources/js/pages/terms.vue?definePage&vue'
import _definePage_default_117 from '/www/wwwroot/pintukasir/resources/js/pages/testimoni.vue?definePage&vue'
import _definePage_default_118 from '/www/wwwroot/pintukasir/resources/js/pages/testimonial.vue?definePage&vue'
import _definePage_default_119 from '/www/wwwroot/pintukasir/resources/js/pages/tutorial.vue?definePage&vue'
import _definePage_default_120 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/index.vue?definePage&vue'
import _definePage_default_121 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/absensi/index.vue?definePage&vue'
import _definePage_default_122 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/crm-broadcast/index.vue?definePage&vue'
import _definePage_default_123 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/fb-modern/index.vue?definePage&vue'
import _definePage_default_124 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/fb-modern/delivery-platforms.vue?definePage&vue'
import _definePage_default_125 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/fb-modern/kds.vue?definePage&vue'
import _definePage_default_126 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/fb-modern/order-type.vue?definePage&vue'
import _definePage_default_127 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/fb-modern/self-order.vue?definePage&vue'
import _definePage_default_128 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/fb-modern/stations.vue?definePage&vue'
import _definePage_default_129 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/fb-modern/tables.vue?definePage&vue'
import _definePage_default_130 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/kasir-lanjutan/cds.vue?definePage&vue'
import _definePage_default_131 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/kasir-lanjutan/refund.vue?definePage&vue'
import _definePage_default_132 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/keuangan/index.vue?definePage&vue'
import _definePage_default_133 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/keuangan/kategori.vue?definePage&vue'
import _definePage_default_134 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/keuangan/pengeluaran.vue?definePage&vue'
import _definePage_default_135 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/laporan/index.vue?definePage&vue'
import _definePage_default_136 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/laporan/dashboard.vue?definePage&vue'
import _definePage_default_137 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/laporan/inventory.vue?definePage&vue'
import _definePage_default_138 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/laporan/laba-rugi.vue?definePage&vue'
import _definePage_default_139 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/laporan/penjualan.vue?definePage&vue'
import _definePage_default_140 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/operasional/ai-voice-order.vue?definePage&vue'
import _definePage_default_141 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/operasional/penjualan.vue?definePage&vue'
import _definePage_default_142 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/operasional/pos-kasir.vue?definePage&vue'
import _definePage_default_143 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/operasional/sistem-antrian.vue?definePage&vue'
import _definePage_default_144 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/pembelian/index.vue?definePage&vue'
import _definePage_default_145 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/pembelian/purchase-order.vue?definePage&vue'
import _definePage_default_146 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/pembelian/receiving.vue?definePage&vue'
import _definePage_default_147 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/pembelian/scan-struk-ai.vue?definePage&vue'
import _definePage_default_148 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/pembelian/supplier.vue?definePage&vue'
import _definePage_default_149 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/produk-inventory/bahan-baku.vue?definePage&vue'
import _definePage_default_150 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/produk-inventory/kategori.vue?definePage&vue'
import _definePage_default_151 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/produk-inventory/modifier.vue?definePage&vue'
import _definePage_default_152 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/produk-inventory/pergerakan-stok.vue?definePage&vue'
import _definePage_default_153 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/produk-inventory/produk.vue?definePage&vue'
import _definePage_default_154 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/produk-inventory/satuan.vue?definePage&vue'
import _definePage_default_155 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/produk-inventory/stock-adjustment.vue?definePage&vue'
import _definePage_default_156 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/produk-inventory/stock-opname.vue?definePage&vue'
import _definePage_default_157 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/promo-voucher-loyalty/kombinasi.vue?definePage&vue'
import _definePage_default_158 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/promo-voucher-loyalty/loyalty.vue?definePage&vue'
import _definePage_default_159 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/promo-voucher-loyalty/promo.vue?definePage&vue'
import _definePage_default_160 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/promo-voucher-loyalty/voucher.vue?definePage&vue'
import _definePage_default_161 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/retail/index.vue?definePage&vue'
import _definePage_default_162 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/retail/barcode.vue?definePage&vue'
import _definePage_default_163 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/retail/harga-grosir.vue?definePage&vue'
import _definePage_default_164 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/retail/kedaluwarsa.vue?definePage&vue'
import _definePage_default_165 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/retail/toggle.vue?definePage&vue'
import _definePage_default_166 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/sistem/index.vue?definePage&vue'
import _definePage_default_167 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/sistem/audit-log.vue?definePage&vue'
import _definePage_default_168 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/sistem/notifikasi.vue?definePage&vue'
import _definePage_default_169 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/sistem/pengaturan.vue?definePage&vue'
import _definePage_default_170 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/sistem/printers.vue?definePage&vue'
import _definePage_default_171 from '/www/wwwroot/pintukasir/resources/js/pages/userguide/sistem/user-role.vue?definePage&vue'
import _definePage_default_172 from '/www/wwwroot/pintukasir/resources/js/pages/vouchers/index.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/',
    name: 'root',
    component: () => import('/www/wwwroot/pintukasir/resources/js/pages/index.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/www/wwwroot/pintukasir/resources/js/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  _mergeRouteRecord(
  {
    path: '/access-control',
    name: 'access-control',
    component: () => import('/www/wwwroot/pintukasir/resources/js/pages/access-control.vue'),
    /* no children */
  },
  _definePage_default_3
  ),
  {
    path: '/apps',
    /* internal name: 'apps' */
    /* no component */
    children: [
      {
        path: 'roles',
        /* internal name: 'apps-roles' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'apps-roles',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/apps/roles/index.vue'),
            /* no children */
          },
  _definePage_default_4
  ),
          {
            path: ':id',
            /* internal name: 'apps-roles-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'edit',
                name: 'apps-roles-id-edit',
                component: () => import('/www/wwwroot/pintukasir/resources/js/pages/apps/roles/[id]/edit.vue'),
                /* no children */
              },
  _definePage_default_5
  )
            ],
          }
        ],
      },
      {
        path: 'user',
        /* internal name: 'apps-user' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-user-list' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'apps-user-list',
                component: () => import('/www/wwwroot/pintukasir/resources/js/pages/apps/user/list/index.vue'),
                /* no children */
              },
  _definePage_default_6
  )
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/attendance',
    /* internal name: 'attendance' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'kiosk',
        name: 'attendance-kiosk',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/attendance/kiosk.vue'),
        /* no children */
      },
  _definePage_default_7
  ),
  _mergeRouteRecord(
      {
        path: 'schedules',
        name: 'attendance-schedules',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/attendance/schedules.vue'),
        /* no children */
      },
  _definePage_default_8
  )
    ],
  },
  {
    path: '/blog',
    /* internal name: 'blog' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'blog',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/blog/index.vue'),
        /* no children */
      },
  _definePage_default_9
  ),
  _mergeRouteRecord(
      {
        path: ':slug',
        name: 'blog-slug',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/blog/[slug].vue'),
        /* no children */
      },
  _definePage_default_10
  )
    ],
  },
  {
    path: '/catalog',
    /* internal name: 'catalog' */
    /* no component */
    children: [
      {
        path: 'categories',
        /* internal name: 'catalog-categories' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'catalog-categories',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/catalog/categories/index.vue'),
            /* no children */
          },
  _definePage_default_11
  )
        ],
      },
      {
        path: 'modifier-groups',
        /* internal name: 'catalog-modifier-groups' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'catalog-modifier-groups',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/catalog/modifier-groups/index.vue'),
            /* no children */
          },
  _definePage_default_12
  ),
          {
            path: ':id',
            /* internal name: 'catalog-modifier-groups-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'edit',
                name: 'catalog-modifier-groups-id-edit',
                component: () => import('/www/wwwroot/pintukasir/resources/js/pages/catalog/modifier-groups/[id]/edit.vue'),
                /* no children */
              },
  _definePage_default_13
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'catalog-modifier-groups-create',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/catalog/modifier-groups/create.vue'),
            /* no children */
          },
  _definePage_default_14
  )
        ],
      },
      {
        path: 'products',
        /* internal name: 'catalog-products' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'catalog-products',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/catalog/products/index.vue'),
            /* no children */
          },
  _definePage_default_15
  ),
          {
            path: ':id',
            /* internal name: 'catalog-products-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'catalog-products-id',
                component: () => import('/www/wwwroot/pintukasir/resources/js/pages/catalog/products/[id]/index.vue'),
                /* no children */
              },
  _definePage_default_16
  ),
  _mergeRouteRecord(
              {
                path: 'edit',
                name: 'catalog-products-id-edit',
                component: () => import('/www/wwwroot/pintukasir/resources/js/pages/catalog/products/[id]/edit.vue'),
                /* no children */
              },
  _definePage_default_17
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'catalog-products-create',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/catalog/products/create.vue'),
            /* no children */
          },
  _definePage_default_18
  )
        ],
      }
    ],
  },
  {
    path: '/crm',
    /* internal name: 'crm' */
    /* no component */
    children: [
      {
        path: 'broadcast-campaigns',
        /* internal name: 'crm-broadcast-campaigns' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'crm-broadcast-campaigns',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/crm/broadcast-campaigns/index.vue'),
            /* no children */
          },
  _definePage_default_19
  ),
          {
            path: ':id',
            /* internal name: 'crm-broadcast-campaigns-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'crm-broadcast-campaigns-id',
                component: () => import('/www/wwwroot/pintukasir/resources/js/pages/crm/broadcast-campaigns/[id]/index.vue'),
                /* no children */
              },
  _definePage_default_20
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'crm-broadcast-campaigns-create',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/crm/broadcast-campaigns/create.vue'),
            /* no children */
          },
  _definePage_default_21
  )
        ],
      },
      {
        path: 'broadcast-templates',
        /* internal name: 'crm-broadcast-templates' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'crm-broadcast-templates',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/crm/broadcast-templates/index.vue'),
            /* no children */
          },
  _definePage_default_22
  ),
          {
            path: ':id',
            /* internal name: 'crm-broadcast-templates-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'edit',
                name: 'crm-broadcast-templates-id-edit',
                component: () => import('/www/wwwroot/pintukasir/resources/js/pages/crm/broadcast-templates/[id]/edit.vue'),
                /* no children */
              },
  _definePage_default_23
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'crm-broadcast-templates-create',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/crm/broadcast-templates/create.vue'),
            /* no children */
          },
  _definePage_default_24
  )
        ],
      }
    ],
  },
  {
    path: '/daftar',
    /* internal name: 'daftar' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'daftar',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/daftar/index.vue'),
        /* no children */
      },
  _definePage_default_25
  ),
      {
        path: 'status',
        /* internal name: 'daftar-status' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':registrationCode',
            name: 'daftar-status-registration-code',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/daftar/status/[registrationCode].vue'),
            /* no children */
          },
  _definePage_default_26
  )
        ],
      }
    ],
  },
  {
    path: '/dashboards',
    /* internal name: 'dashboards' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'analytics',
        name: 'dashboards-analytics',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/dashboards/analytics.vue'),
        /* no children */
      },
  _definePage_default_27
  )
    ],
  },
  {
    path: '/expense',
    /* internal name: 'expense' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'expense',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/expense/index.vue'),
        /* no children */
      },
  _definePage_default_28
  ),
      {
        path: ':id',
        /* internal name: 'expense-id' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'edit',
            name: 'expense-id-edit',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/expense/[id]/edit.vue'),
            /* no children */
          },
  _definePage_default_29
  )
        ],
      },
      {
        path: 'categories',
        /* internal name: 'expense-categories' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'expense-categories',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/expense/categories/index.vue'),
            /* no children */
          },
  _definePage_default_30
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'create',
        name: 'expense-create',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/expense/create.vue'),
        /* no children */
      },
  _definePage_default_31
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/fitur',
    name: 'fitur',
    component: () => import('/www/wwwroot/pintukasir/resources/js/pages/fitur.vue'),
    /* no children */
  },
  _definePage_default_32
  ),
  _mergeRouteRecord(
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('/www/wwwroot/pintukasir/resources/js/pages/forgot-password.vue'),
    /* no children */
  },
  _definePage_default_33
  ),
  _mergeRouteRecord(
  {
    path: '/help',
    name: 'help',
    component: () => import('/www/wwwroot/pintukasir/resources/js/pages/help.vue'),
    /* no children */
  },
  _definePage_default_34
  ),
  {
    path: '/inventory',
    /* internal name: 'inventory' */
    /* no component */
    children: [
      {
        path: 'ingredients',
        /* internal name: 'inventory-ingredients' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'inventory-ingredients',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/inventory/ingredients/index.vue'),
            /* no children */
          },
  _definePage_default_35
  ),
          {
            path: ':id',
            /* internal name: 'inventory-ingredients-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'inventory-ingredients-id',
                component: () => import('/www/wwwroot/pintukasir/resources/js/pages/inventory/ingredients/[id]/index.vue'),
                /* no children */
              },
  _definePage_default_36
  ),
  _mergeRouteRecord(
              {
                path: 'edit',
                name: 'inventory-ingredients-id-edit',
                component: () => import('/www/wwwroot/pintukasir/resources/js/pages/inventory/ingredients/[id]/edit.vue'),
                /* no children */
              },
  _definePage_default_37
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'inventory-ingredients-create',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/inventory/ingredients/create.vue'),
            /* no children */
          },
  _definePage_default_38
  )
        ],
      },
      {
        path: 'stock-adjustment',
        /* internal name: 'inventory-stock-adjustment' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'inventory-stock-adjustment',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/inventory/stock-adjustment/index.vue'),
            /* no children */
          },
  _definePage_default_39
  )
        ],
      },
      {
        path: 'stock-movements',
        /* internal name: 'inventory-stock-movements' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'inventory-stock-movements',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/inventory/stock-movements/index.vue'),
            /* no children */
          },
  _definePage_default_40
  )
        ],
      },
      {
        path: 'stock-opnames',
        /* internal name: 'inventory-stock-opnames' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'inventory-stock-opnames',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/inventory/stock-opnames/index.vue'),
            /* no children */
          },
  _definePage_default_41
  ),
          {
            path: ':id',
            /* internal name: 'inventory-stock-opnames-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'inventory-stock-opnames-id',
                component: () => import('/www/wwwroot/pintukasir/resources/js/pages/inventory/stock-opnames/[id]/index.vue'),
                /* no children */
              },
  _definePage_default_42
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'inventory-stock-opnames-create',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/inventory/stock-opnames/create.vue'),
            /* no children */
          },
  _definePage_default_43
  )
        ],
      },
      {
        path: 'units',
        /* internal name: 'inventory-units' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'inventory-units',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/inventory/units/index.vue'),
            /* no children */
          },
  _definePage_default_44
  )
        ],
      }
    ],
  },
  {
    path: '/kds',
    /* internal name: 'kds' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'kds',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/kds/index.vue'),
        /* no children */
      },
  _definePage_default_45
  ),
  _mergeRouteRecord(
      {
        path: ':stationId',
        name: 'kds-station-id',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/kds/[stationId].vue'),
        /* no children */
      },
  _definePage_default_46
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/kontak',
    name: 'kontak',
    component: () => import('/www/wwwroot/pintukasir/resources/js/pages/kontak.vue'),
    /* no children */
  },
  _definePage_default_47
  ),
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/www/wwwroot/pintukasir/resources/js/pages/login.vue'),
    /* no children */
  },
  _definePage_default_48
  ),
  {
    path: '/loyalty',
    /* internal name: 'loyalty' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'loyalty',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/loyalty/index.vue'),
        /* no children */
      },
  _definePage_default_49
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/www/wwwroot/pintukasir/resources/js/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_50
  ),
  {
    path: '/order',
    /* internal name: 'order' */
    /* no component */
    children: [
      {
        path: 'components',
        /* internal name: 'order-components' */
        /* no component */
        children: [
          {
            path: 'OrderProgress',
            name: 'order-components-order-progress',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/order/components/OrderProgress.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'scan',
        /* internal name: 'order-scan' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':qrToken',
            name: 'order-scan-qr-token',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/order/scan/[qrToken].vue'),
            /* no children */
          },
  _definePage_default_51
  )
        ],
      },
      {
        path: 'session-token',
        /* internal name: 'order-session-token' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'checkout',
            name: 'order-session-token-checkout',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/order/session-token/checkout.vue'),
            /* no children */
          },
  _definePage_default_52
  ),
  _mergeRouteRecord(
          {
            path: 'identify',
            name: 'order-session-token-identify',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/order/session-token/identify.vue'),
            /* no children */
          },
  _definePage_default_53
  ),
  _mergeRouteRecord(
          {
            path: 'menu',
            name: 'order-session-token-menu',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/order/session-token/menu.vue'),
            /* no children */
          },
  _definePage_default_54
  ),
  _mergeRouteRecord(
          {
            path: 'payment',
            name: 'order-session-token-payment',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/order/session-token/payment.vue'),
            /* no children */
          },
  _definePage_default_55
  ),
  _mergeRouteRecord(
          {
            path: 'status',
            name: 'order-session-token-status',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/order/session-token/status.vue'),
            /* no children */
          },
  _definePage_default_56
  )
        ],
      }
    ],
  },
  {
    path: '/platform',
    /* internal name: 'platform' */
    /* no component */
    children: [
      {
        path: 'blog-posts',
        /* internal name: 'platform-blog-posts' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'platform-blog-posts',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/platform/blog-posts/index.vue'),
            /* no children */
          },
  _definePage_default_57
  ),
          {
            path: ':id',
            /* internal name: 'platform-blog-posts-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'edit',
                name: 'platform-blog-posts-id-edit',
                component: () => import('/www/wwwroot/pintukasir/resources/js/pages/platform/blog-posts/[id]/edit.vue'),
                /* no children */
              },
  _definePage_default_58
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'platform-blog-posts-create',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/platform/blog-posts/create.vue'),
            /* no children */
          },
  _definePage_default_59
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'login',
        name: 'platform-login',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/platform/login.vue'),
        /* no children */
      },
  _definePage_default_60
  ),
      {
        path: 'orders',
        /* internal name: 'platform-orders' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'platform-orders',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/platform/orders/index.vue'),
            /* no children */
          },
  _definePage_default_61
  )
        ],
      },
      {
        path: 'registrations',
        /* internal name: 'platform-registrations' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'platform-registrations',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/platform/registrations/index.vue'),
            /* no children */
          },
  _definePage_default_62
  )
        ],
      },
      {
        path: 'seo-settings',
        /* internal name: 'platform-seo-settings' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'platform-seo-settings',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/platform/seo-settings/index.vue'),
            /* no children */
          },
  _definePage_default_63
  )
        ],
      },
      {
        path: 'settings',
        /* internal name: 'platform-settings' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'platform-settings',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/platform/settings/index.vue'),
            /* no children */
          },
  _definePage_default_64
  )
        ],
      },
      {
        path: 'subscriptions',
        /* internal name: 'platform-subscriptions' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'platform-subscriptions',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/platform/subscriptions/index.vue'),
            /* no children */
          },
  _definePage_default_65
  )
        ],
      },
      {
        path: 'tenants',
        /* internal name: 'platform-tenants' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'platform-tenants',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/platform/tenants/index.vue'),
            /* no children */
          },
  _definePage_default_66
  ),
          {
            path: ':id',
            /* internal name: 'platform-tenants-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'edit',
                name: 'platform-tenants-id-edit',
                component: () => import('/www/wwwroot/pintukasir/resources/js/pages/platform/tenants/[id]/edit.vue'),
                /* no children */
              },
  _definePage_default_67
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'platform-tenants-create',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/platform/tenants/create.vue'),
            /* no children */
          },
  _definePage_default_68
  )
        ],
      },
      {
        path: 'testimonials',
        /* internal name: 'platform-testimonials' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'platform-testimonials',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/platform/testimonials/index.vue'),
            /* no children */
          },
  _definePage_default_69
  )
        ],
      },
      {
        path: 'tickets',
        /* internal name: 'platform-tickets' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'platform-tickets',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/platform/tickets/index.vue'),
            /* no children */
          },
  _definePage_default_70
  ),
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'platform-tickets-id',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/platform/tickets/[id].vue'),
            /* no children */
          },
  _definePage_default_71
  )
        ],
      }
    ],
  },
  {
    path: '/pos',
    /* internal name: 'pos' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'pos',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/pos/index.vue'),
        /* no children */
      },
  _definePage_default_72
  ),
  _mergeRouteRecord(
      {
        path: 'index-copy',
        name: 'pos-index-copy',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/pos/index-copy.vue'),
        /* no children */
      },
  _definePage_default_73
  ),
      {
        path: 'qris-print',
        /* internal name: 'pos-qris-print' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'pos-qris-print-id',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/pos/qris-print/[id].vue'),
            /* no children */
          },
  _definePage_default_74
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'queue-board',
        name: 'pos-queue-board',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/pos/queue-board.vue'),
        /* no children */
      },
  _definePage_default_75
  ),
      {
        path: 'receipt',
        /* internal name: 'pos-receipt' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'pos-receipt-id',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/pos/receipt/[id].vue'),
            /* no children */
          },
  _definePage_default_76
  )
        ],
      }
    ],
  },
  {
    path: '/pos-display',
    /* internal name: 'pos-display' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':shiftId',
        name: 'pos-display-shift-id',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/pos-display/[shiftId].vue'),
        /* no children */
      },
  _definePage_default_77
  ),
  _mergeRouteRecord(
      {
        path: 'connect',
        name: 'pos-display-connect',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/pos-display/connect.vue'),
        /* no children */
      },
  _definePage_default_78
  ),
  _mergeRouteRecord(
      {
        path: 'queue-board',
        name: 'pos-display-queue-board',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/pos-display/queue-board.vue'),
        /* no children */
      },
  _definePage_default_79
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('/www/wwwroot/pintukasir/resources/js/pages/privacy.vue'),
    /* no children */
  },
  _definePage_default_80
  ),
  {
    path: '/profile',
    name: 'profile',
    component: () => import('/www/wwwroot/pintukasir/resources/js/pages/profile.vue'),
    /* no children */
  },
  {
    path: '/promotions',
    /* internal name: 'promotions' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'promotions',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/promotions/index.vue'),
        /* no children */
      },
  _definePage_default_81
  )
    ],
  },
  {
    path: '/purchase',
    /* internal name: 'purchase' */
    /* no component */
    children: [
      {
        path: 'orders',
        /* internal name: 'purchase-orders' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'purchase-orders',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/purchase/orders/index.vue'),
            /* no children */
          },
  _definePage_default_82
  ),
          {
            path: ':id',
            /* internal name: 'purchase-orders-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'purchase-orders-id',
                component: () => import('/www/wwwroot/pintukasir/resources/js/pages/purchase/orders/[id]/index.vue'),
                /* no children */
              },
  _definePage_default_83
  ),
  _mergeRouteRecord(
              {
                path: 'edit',
                name: 'purchase-orders-id-edit',
                component: () => import('/www/wwwroot/pintukasir/resources/js/pages/purchase/orders/[id]/edit.vue'),
                /* no children */
              },
  _definePage_default_84
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'purchase-orders-create',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/purchase/orders/create.vue'),
            /* no children */
          },
  _definePage_default_85
  )
        ],
      },
      {
        path: 'receipt-scan',
        /* internal name: 'purchase-receipt-scan' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'purchase-receipt-scan',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/purchase/receipt-scan/index.vue'),
            /* no children */
          },
  _definePage_default_86
  ),
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'purchase-receipt-scan-id',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/purchase/receipt-scan/[id].vue'),
            /* no children */
          },
  _definePage_default_87
  )
        ],
      },
      {
        path: 'receivings',
        /* internal name: 'purchase-receivings' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'purchase-receivings',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/purchase/receivings/index.vue'),
            /* no children */
          },
  _definePage_default_88
  ),
          {
            path: ':id',
            /* internal name: 'purchase-receivings-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'purchase-receivings-id',
                component: () => import('/www/wwwroot/pintukasir/resources/js/pages/purchase/receivings/[id]/index.vue'),
                /* no children */
              },
  _definePage_default_89
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'purchase-receivings-create',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/purchase/receivings/create.vue'),
            /* no children */
          },
  _definePage_default_90
  )
        ],
      },
      {
        path: 'suppliers',
        /* internal name: 'purchase-suppliers' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'purchase-suppliers',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/purchase/suppliers/index.vue'),
            /* no children */
          },
  _definePage_default_91
  ),
          {
            path: ':id',
            /* internal name: 'purchase-suppliers-id' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'edit',
                name: 'purchase-suppliers-id-edit',
                component: () => import('/www/wwwroot/pintukasir/resources/js/pages/purchase/suppliers/[id]/edit.vue'),
                /* no children */
              },
  _definePage_default_92
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'purchase-suppliers-create',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/purchase/suppliers/create.vue'),
            /* no children */
          },
  _definePage_default_93
  )
        ],
      }
    ],
  },
  {
    path: '/reports',
    /* internal name: 'reports' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'attendance',
        name: 'reports-attendance',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/reports/attendance.vue'),
        /* no children */
      },
  _definePage_default_94
  ),
  _mergeRouteRecord(
      {
        path: 'dashboard',
        name: 'reports-dashboard',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/reports/dashboard.vue'),
        /* no children */
      },
  _definePage_default_95
  ),
  _mergeRouteRecord(
      {
        path: 'expiring-stock',
        name: 'reports-expiring-stock',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/reports/expiring-stock.vue'),
        /* no children */
      },
  _definePage_default_96
  ),
  _mergeRouteRecord(
      {
        path: 'inventory',
        name: 'reports-inventory',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/reports/inventory.vue'),
        /* no children */
      },
  _definePage_default_97
  ),
  _mergeRouteRecord(
      {
        path: 'profit-loss',
        name: 'reports-profit-loss',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/reports/profit-loss.vue'),
        /* no children */
      },
  _definePage_default_98
  ),
  _mergeRouteRecord(
      {
        path: 'sales',
        name: 'reports-sales',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/reports/sales.vue'),
        /* no children */
      },
  _definePage_default_99
  )
    ],
  },
  {
    path: '/sales',
    /* internal name: 'sales' */
    /* no component */
    children: [
      {
        path: 'orders',
        /* internal name: 'sales-orders' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'sales-orders',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/sales/orders/index.vue'),
            /* no children */
          },
  _definePage_default_100
  ),
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'sales-orders-id',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/sales/orders/[id].vue'),
            /* no children */
          },
  _definePage_default_101
  )
        ],
      },
      {
        path: 'shifts',
        /* internal name: 'sales-shifts' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'sales-shifts',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/sales/shifts/index.vue'),
            /* no children */
          },
  _definePage_default_102
  )
        ],
      }
    ],
  },
  {
    path: '/settings',
    /* internal name: 'settings' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':tab',
        name: 'settings-tab',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/settings/[tab].vue'),
        /* no children */
      },
  _definePage_default_103
  ),
  _mergeRouteRecord(
      {
        path: 'ai-status',
        name: 'settings-ai-status',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/settings/ai-status.vue'),
        /* no children */
      },
  _definePage_default_104
  ),
  _mergeRouteRecord(
      {
        path: 'delivery-platforms',
        name: 'settings-delivery-platforms',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/settings/delivery-platforms.vue'),
        /* no children */
      },
  _definePage_default_105
  ),
  _mergeRouteRecord(
      {
        path: 'order-types',
        name: 'settings-order-types',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/settings/order-types.vue'),
        /* no children */
      },
  _definePage_default_106
  ),
  _mergeRouteRecord(
      {
        path: 'printers',
        name: 'settings-printers',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/settings/printers.vue'),
        /* no children */
      },
  _definePage_default_107
  ),
  _mergeRouteRecord(
      {
        path: 'stations',
        name: 'settings-stations',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/settings/stations.vue'),
        /* no children */
      },
  _definePage_default_108
  )
    ],
  },
  {
    path: '/staff',
    /* internal name: 'staff' */
    /* no component */
    children: [
      {
        path: 'pin-setup',
        /* internal name: 'staff-pin-setup' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':token',
            name: 'staff-pin-setup-token',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/staff/pin-setup/[token].vue'),
            /* no children */
          },
  _definePage_default_109
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/support',
    name: 'support-parent',
    component: () => import('/www/wwwroot/pintukasir/resources/js/pages/support.vue'),
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'support',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/support/index.vue'),
        /* no children */
      },
  _definePage_default_110
  ),
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'support-id',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/support/[id].vue'),
        /* no children */
      },
  _definePage_default_111
  ),
  _mergeRouteRecord(
      {
        path: 'create',
        name: 'support-create',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/support/create.vue'),
        /* no children */
      },
  _definePage_default_112
  )
    ],
  },
  _definePage_default_113
  ),
  {
    path: '/tables',
    /* internal name: 'tables' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'tables',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/tables/index.vue'),
        /* no children */
      },
  _definePage_default_114
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/tentang-kami',
    name: 'tentang-kami',
    component: () => import('/www/wwwroot/pintukasir/resources/js/pages/tentang-kami.vue'),
    /* no children */
  },
  _definePage_default_115
  ),
  _mergeRouteRecord(
  {
    path: '/terms',
    name: 'terms',
    component: () => import('/www/wwwroot/pintukasir/resources/js/pages/terms.vue'),
    /* no children */
  },
  _definePage_default_116
  ),
  _mergeRouteRecord(
  {
    path: '/testimoni',
    name: 'testimoni',
    component: () => import('/www/wwwroot/pintukasir/resources/js/pages/testimoni.vue'),
    /* no children */
  },
  _definePage_default_117
  ),
  _mergeRouteRecord(
  {
    path: '/testimonial',
    name: 'testimonial',
    component: () => import('/www/wwwroot/pintukasir/resources/js/pages/testimonial.vue'),
    /* no children */
  },
  _definePage_default_118
  ),
  _mergeRouteRecord(
  {
    path: '/tutorial',
    name: 'tutorial',
    component: () => import('/www/wwwroot/pintukasir/resources/js/pages/tutorial.vue'),
    /* no children */
  },
  _definePage_default_119
  ),
  {
    path: '/userguide',
    /* internal name: 'userguide' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'userguide',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/index.vue'),
        /* no children */
      },
  _definePage_default_120
  ),
      {
        path: 'absensi',
        /* internal name: 'userguide-absensi' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'userguide-absensi',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/absensi/index.vue'),
            /* no children */
          },
  _definePage_default_121
  )
        ],
      },
      {
        path: 'crm-broadcast',
        /* internal name: 'userguide-crm-broadcast' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'userguide-crm-broadcast',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/crm-broadcast/index.vue'),
            /* no children */
          },
  _definePage_default_122
  )
        ],
      },
      {
        path: 'fb-modern',
        /* internal name: 'userguide-fb-modern' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'userguide-fb-modern',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/fb-modern/index.vue'),
            /* no children */
          },
  _definePage_default_123
  ),
  _mergeRouteRecord(
          {
            path: 'delivery-platforms',
            name: 'userguide-fb-modern-delivery-platforms',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/fb-modern/delivery-platforms.vue'),
            /* no children */
          },
  _definePage_default_124
  ),
  _mergeRouteRecord(
          {
            path: 'kds',
            name: 'userguide-fb-modern-kds',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/fb-modern/kds.vue'),
            /* no children */
          },
  _definePage_default_125
  ),
  _mergeRouteRecord(
          {
            path: 'order-type',
            name: 'userguide-fb-modern-order-type',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/fb-modern/order-type.vue'),
            /* no children */
          },
  _definePage_default_126
  ),
  _mergeRouteRecord(
          {
            path: 'self-order',
            name: 'userguide-fb-modern-self-order',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/fb-modern/self-order.vue'),
            /* no children */
          },
  _definePage_default_127
  ),
  _mergeRouteRecord(
          {
            path: 'stations',
            name: 'userguide-fb-modern-stations',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/fb-modern/stations.vue'),
            /* no children */
          },
  _definePage_default_128
  ),
  _mergeRouteRecord(
          {
            path: 'tables',
            name: 'userguide-fb-modern-tables',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/fb-modern/tables.vue'),
            /* no children */
          },
  _definePage_default_129
  )
        ],
      },
      {
        path: 'kasir-lanjutan',
        /* internal name: 'userguide-kasir-lanjutan' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'cds',
            name: 'userguide-kasir-lanjutan-cds',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/kasir-lanjutan/cds.vue'),
            /* no children */
          },
  _definePage_default_130
  ),
  _mergeRouteRecord(
          {
            path: 'refund',
            name: 'userguide-kasir-lanjutan-refund',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/kasir-lanjutan/refund.vue'),
            /* no children */
          },
  _definePage_default_131
  )
        ],
      },
      {
        path: 'keuangan',
        /* internal name: 'userguide-keuangan' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'userguide-keuangan',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/keuangan/index.vue'),
            /* no children */
          },
  _definePage_default_132
  ),
  _mergeRouteRecord(
          {
            path: 'kategori',
            name: 'userguide-keuangan-kategori',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/keuangan/kategori.vue'),
            /* no children */
          },
  _definePage_default_133
  ),
  _mergeRouteRecord(
          {
            path: 'pengeluaran',
            name: 'userguide-keuangan-pengeluaran',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/keuangan/pengeluaran.vue'),
            /* no children */
          },
  _definePage_default_134
  )
        ],
      },
      {
        path: 'laporan',
        /* internal name: 'userguide-laporan' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'userguide-laporan',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/laporan/index.vue'),
            /* no children */
          },
  _definePage_default_135
  ),
  _mergeRouteRecord(
          {
            path: 'dashboard',
            name: 'userguide-laporan-dashboard',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/laporan/dashboard.vue'),
            /* no children */
          },
  _definePage_default_136
  ),
  _mergeRouteRecord(
          {
            path: 'inventory',
            name: 'userguide-laporan-inventory',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/laporan/inventory.vue'),
            /* no children */
          },
  _definePage_default_137
  ),
  _mergeRouteRecord(
          {
            path: 'laba-rugi',
            name: 'userguide-laporan-laba-rugi',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/laporan/laba-rugi.vue'),
            /* no children */
          },
  _definePage_default_138
  ),
  _mergeRouteRecord(
          {
            path: 'penjualan',
            name: 'userguide-laporan-penjualan',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/laporan/penjualan.vue'),
            /* no children */
          },
  _definePage_default_139
  )
        ],
      },
      {
        path: 'operasional',
        /* internal name: 'userguide-operasional' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'ai-voice-order',
            name: 'userguide-operasional-ai-voice-order',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/operasional/ai-voice-order.vue'),
            /* no children */
          },
  _definePage_default_140
  ),
  _mergeRouteRecord(
          {
            path: 'penjualan',
            name: 'userguide-operasional-penjualan',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/operasional/penjualan.vue'),
            /* no children */
          },
  _definePage_default_141
  ),
  _mergeRouteRecord(
          {
            path: 'pos-kasir',
            name: 'userguide-operasional-pos-kasir',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/operasional/pos-kasir.vue'),
            /* no children */
          },
  _definePage_default_142
  ),
  _mergeRouteRecord(
          {
            path: 'sistem-antrian',
            name: 'userguide-operasional-sistem-antrian',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/operasional/sistem-antrian.vue'),
            /* no children */
          },
  _definePage_default_143
  )
        ],
      },
      {
        path: 'pembelian',
        /* internal name: 'userguide-pembelian' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'userguide-pembelian',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/pembelian/index.vue'),
            /* no children */
          },
  _definePage_default_144
  ),
  _mergeRouteRecord(
          {
            path: 'purchase-order',
            name: 'userguide-pembelian-purchase-order',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/pembelian/purchase-order.vue'),
            /* no children */
          },
  _definePage_default_145
  ),
  _mergeRouteRecord(
          {
            path: 'receiving',
            name: 'userguide-pembelian-receiving',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/pembelian/receiving.vue'),
            /* no children */
          },
  _definePage_default_146
  ),
  _mergeRouteRecord(
          {
            path: 'scan-struk-ai',
            name: 'userguide-pembelian-scan-struk-ai',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/pembelian/scan-struk-ai.vue'),
            /* no children */
          },
  _definePage_default_147
  ),
  _mergeRouteRecord(
          {
            path: 'supplier',
            name: 'userguide-pembelian-supplier',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/pembelian/supplier.vue'),
            /* no children */
          },
  _definePage_default_148
  )
        ],
      },
      {
        path: 'produk-inventory',
        /* internal name: 'userguide-produk-inventory' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'bahan-baku',
            name: 'userguide-produk-inventory-bahan-baku',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/produk-inventory/bahan-baku.vue'),
            /* no children */
          },
  _definePage_default_149
  ),
  _mergeRouteRecord(
          {
            path: 'kategori',
            name: 'userguide-produk-inventory-kategori',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/produk-inventory/kategori.vue'),
            /* no children */
          },
  _definePage_default_150
  ),
  _mergeRouteRecord(
          {
            path: 'modifier',
            name: 'userguide-produk-inventory-modifier',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/produk-inventory/modifier.vue'),
            /* no children */
          },
  _definePage_default_151
  ),
  _mergeRouteRecord(
          {
            path: 'pergerakan-stok',
            name: 'userguide-produk-inventory-pergerakan-stok',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/produk-inventory/pergerakan-stok.vue'),
            /* no children */
          },
  _definePage_default_152
  ),
  _mergeRouteRecord(
          {
            path: 'produk',
            name: 'userguide-produk-inventory-produk',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/produk-inventory/produk.vue'),
            /* no children */
          },
  _definePage_default_153
  ),
  _mergeRouteRecord(
          {
            path: 'satuan',
            name: 'userguide-produk-inventory-satuan',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/produk-inventory/satuan.vue'),
            /* no children */
          },
  _definePage_default_154
  ),
  _mergeRouteRecord(
          {
            path: 'stock-adjustment',
            name: 'userguide-produk-inventory-stock-adjustment',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/produk-inventory/stock-adjustment.vue'),
            /* no children */
          },
  _definePage_default_155
  ),
  _mergeRouteRecord(
          {
            path: 'stock-opname',
            name: 'userguide-produk-inventory-stock-opname',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/produk-inventory/stock-opname.vue'),
            /* no children */
          },
  _definePage_default_156
  )
        ],
      },
      {
        path: 'promo-voucher-loyalty',
        /* internal name: 'userguide-promo-voucher-loyalty' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'kombinasi',
            name: 'userguide-promo-voucher-loyalty-kombinasi',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/promo-voucher-loyalty/kombinasi.vue'),
            /* no children */
          },
  _definePage_default_157
  ),
  _mergeRouteRecord(
          {
            path: 'loyalty',
            name: 'userguide-promo-voucher-loyalty-loyalty',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/promo-voucher-loyalty/loyalty.vue'),
            /* no children */
          },
  _definePage_default_158
  ),
  _mergeRouteRecord(
          {
            path: 'promo',
            name: 'userguide-promo-voucher-loyalty-promo',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/promo-voucher-loyalty/promo.vue'),
            /* no children */
          },
  _definePage_default_159
  ),
  _mergeRouteRecord(
          {
            path: 'voucher',
            name: 'userguide-promo-voucher-loyalty-voucher',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/promo-voucher-loyalty/voucher.vue'),
            /* no children */
          },
  _definePage_default_160
  )
        ],
      },
      {
        path: 'retail',
        /* internal name: 'userguide-retail' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'userguide-retail',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/retail/index.vue'),
            /* no children */
          },
  _definePage_default_161
  ),
  _mergeRouteRecord(
          {
            path: 'barcode',
            name: 'userguide-retail-barcode',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/retail/barcode.vue'),
            /* no children */
          },
  _definePage_default_162
  ),
  _mergeRouteRecord(
          {
            path: 'harga-grosir',
            name: 'userguide-retail-harga-grosir',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/retail/harga-grosir.vue'),
            /* no children */
          },
  _definePage_default_163
  ),
  _mergeRouteRecord(
          {
            path: 'kedaluwarsa',
            name: 'userguide-retail-kedaluwarsa',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/retail/kedaluwarsa.vue'),
            /* no children */
          },
  _definePage_default_164
  ),
  _mergeRouteRecord(
          {
            path: 'toggle',
            name: 'userguide-retail-toggle',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/retail/toggle.vue'),
            /* no children */
          },
  _definePage_default_165
  )
        ],
      },
      {
        path: 'sistem',
        /* internal name: 'userguide-sistem' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'userguide-sistem',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/sistem/index.vue'),
            /* no children */
          },
  _definePage_default_166
  ),
  _mergeRouteRecord(
          {
            path: 'audit-log',
            name: 'userguide-sistem-audit-log',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/sistem/audit-log.vue'),
            /* no children */
          },
  _definePage_default_167
  ),
  _mergeRouteRecord(
          {
            path: 'notifikasi',
            name: 'userguide-sistem-notifikasi',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/sistem/notifikasi.vue'),
            /* no children */
          },
  _definePage_default_168
  ),
  _mergeRouteRecord(
          {
            path: 'pengaturan',
            name: 'userguide-sistem-pengaturan',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/sistem/pengaturan.vue'),
            /* no children */
          },
  _definePage_default_169
  ),
  _mergeRouteRecord(
          {
            path: 'printers',
            name: 'userguide-sistem-printers',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/sistem/printers.vue'),
            /* no children */
          },
  _definePage_default_170
  ),
  _mergeRouteRecord(
          {
            path: 'user-role',
            name: 'userguide-sistem-user-role',
            component: () => import('/www/wwwroot/pintukasir/resources/js/pages/userguide/sistem/user-role.vue'),
            /* no children */
          },
  _definePage_default_171
  )
        ],
      }
    ],
  },
  {
    path: '/vouchers',
    /* internal name: 'vouchers' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'vouchers',
        component: () => import('/www/wwwroot/pintukasir/resources/js/pages/vouchers/index.vue'),
        /* no children */
      },
  _definePage_default_172
  )
    ],
  }
]
